// @ts-expect-error not migrated to TS
import PortalMigrationBanner from 'EmailComponents/portalMigration/PortalMigrationBanner';
import { getPortalMigrationEndDate, getPortalMigrationNewHoistingHublet, getPortalMigrationStartDate, getPortalMigrationStatus // @ts-expect-error not migrated to TS
} from 'EmailData/selectors/portalMigration';
import { getCanCreateClassicEmail, getEmailTypesAuthedFor, getHasAccessToSeamlessPortalMigration, getIsUngatedForGenerateAITranslatedEmail // @ts-expect-error not migrated to TS
} from 'EmailData/selectors/user';
// @ts-expect-error not migrated to TS
import { useReviewData } from 'content-label-lib/hooks/useReviewData';
// @ts-expect-error not migrated to TS
import EmptyStateRow from 'email-management-lib/refactor/components/manage/EmptyStateRow';
// @ts-expect-error not migrated to TS
import { getHasSeenEmailInsights } from 'email-management-lib/refactor/selectors/userAttributes';
import { trackDashboardInteraction } from 'EmailComponents/utils/tracking';
import { dashboardType, noMigrationsCategory } from 'EmailData/constants/portalMigration';
import PortalIdParser from 'PortalIdParser';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import { FILTER, SEARCH } from 'email-management-lib/Shared/constants/manage';
import { fetchSubscriptionsInFrameworkTable } from 'email-management-lib/refactor/actions/manage/frameworkTable';
import { fetchTeamsByUser } from 'email-management-lib/refactor/actions/manage/general';
import FrameworkTableActions from 'email-management-lib/refactor/components/manage/frameworkTable/FrameworkTableActions';
import BulkActionsHeaderContainer from 'email-management-lib/refactor/components/manage/frameworkTable/bulkActions/BulkActionsHeaderContainer';
import DeletedViewBulkActions from 'email-management-lib/refactor/components/manage/frameworkTable/bulkActions/DeletedViewBulkActions';
import IssuesViewEmptyState from 'email-management-lib/refactor/components/manage/frameworkTable/components/emptyState/IssuesViewEmptyState';
import FrameworkTableFilters from 'email-management-lib/refactor/components/manage/frameworkTable/filters/FrameworkTableFilters';
import useRenderCustomColumn from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useRenderCustomColumn';
import withProviderReferenceResolvers from 'email-management-lib/refactor/components/manage/frameworkTable/withProviderReferenceResolvers';
import { FEEDBACK_IDS } from 'email-management-lib/refactor/constants/feedback';
import useHasUsedAITranslation from 'email-management-lib/refactor/hooks/useHasUsedAITranslation';
import { getIsUngatedForAiInsights } from 'email-management-lib/refactor/selectors/user';
import { getHasSeenPortalMigrationAlert, setHasSeenPortalMigrationAlert } from 'email-management-lib/refactor/utils/portalMigration';
import { getIsDeletedView, getIsIssuesView } from 'email-management-lib/refactor/utils/views';
import enviro from 'enviro';
import ListingLibFilters from 'framework-listing-lib/filters/ListingLibFilters';
import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import useFetchCrmObjectType from 'framework-listing-lib/hooks/useFetchCrmObjectType';
import ListingLibLayout from 'framework-listing-lib/layout/ListingLibLayout';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { gate } from 'hub-http/gates';
import { useSetupEarlyPreviewCache } from 'messaging-editing-lib/hooks/useEarlyPreviewCache';
import useHasAllGates from 'messaging-management-lib/user/hooks/useHasAllGates';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import emailAIInsightsConfig from 'ui-coaching-tips-shared-config/config/emailAIInsightsConfig';
import emailTranslationConfig from 'ui-coaching-tips-shared-config/config/emailTranslationConfig';
import UICoachingTips from 'ui-coaching-tips/UICoachingTips';
import ErrorMarker from './ErrorMarker';
import SuccessMarker from './SuccessMarker';
import DeletedViewEmptyState from './components/emptyState/DeletedViewEmptyState';
import useEmailUIModeProps from './hooks/useEmailUIModeProps';
import useIsUngatedForNewFrameworkFolders from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useIsUngatedForNewFrameworkFolders';
import useFrameworkFoldersRouteUpdate from './hooks/useFrameworkFoldersRouteUpdate';
import FoldersViewEmptyState from './components/emptyState/FoldersViewEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MIN_EMAILS_FOR_TRANSLATION_COACHING_TIP = 15;
const ResolvedListingLibLayout = withProviderReferenceResolvers(ListingLibLayout);
const ResolvedListingLibFilters = withProviderReferenceResolvers(ListingLibFilters);
function FrameworkTable(ownProps) {
  const {
    feedbackClient,
    hasArchivedEmails,
    hasUsersAndTeamsAccess,
    listMode,
    onClearEmailSearch,
    portalHasEmails,
    selectState,
    selectedViewPath,
    shouldDisableCreateEmailAction
  } = ownProps;
  useFrameworkFoldersRouteUpdate();
  const isIssuesView = getIsIssuesView();
  const isDeletedView = getIsDeletedView();
  const dispatch = useDispatch();
  const {
    filters: listingFilters,
    onClearFilters
  } = useCrmObjectTypeListingFilters();
  const {
    hasUsedAiTranslation,
    isFetchingUserHasUsedAITranslation
  } = useHasUsedAITranslation();
  useEffect(() => {
    dispatch(fetchTeamsByUser());
  }, [dispatch]);
  const canCreateClassicEmail = useSelector(getCanCreateClassicEmail);
  const emailTypesAuthedFor = useSelector(getEmailTypesAuthedFor);
  const isUngatedForAiInsights = useSelector(getIsUngatedForAiInsights);
  const hasSeenEmailInsights = useSelector(getHasSeenEmailInsights);
  const isUngatedForGenerateTranslatedVersion = useSelector(getIsUngatedForGenerateAITranslatedEmail);
  const hasAllGates = useHasAllGates();
  const isUngatedForTimezoneUtil = hasAllGates(gate('UserSetup:TimezoneUtil'));
  const isUngatedForNewFrameworkFolders = useIsUngatedForNewFrameworkFolders();
  const emailUIModeProps = useEmailUIModeProps();
  const columnsToDisplay = useMemo(() => {
    if (isUngatedForNewFrameworkFolders && (emailUIModeProps === null || emailUIModeProps === void 0 ? void 0 : emailUIModeProps.currentUIMode) === 'FOLDERS') {
      return ['hs_name', 'hs_type', 'hs_created_by_user_id'];
    }
    return [];
  }, [emailUIModeProps === null || emailUIModeProps === void 0 ? void 0 : emailUIModeProps.currentUIMode, isUngatedForNewFrameworkFolders]);
  useSetupEarlyPreviewCache();
  useEffect(() => {
    dispatch(fetchSubscriptionsInFrameworkTable());
  }, [dispatch]);
  useEffect(() => {
    if (isIssuesView && enviro.isProd() && feedbackClient) {
      feedbackClient.loadSurvey('CSAT', FEEDBACK_IDS.ISSUES_VIEW);
    }
  }, [feedbackClient, isIssuesView]);
  useEffect(() => {
    const shouldShowInsightsSurvey = enviro.isProd() && feedbackClient && isUngatedForAiInsights && hasSeenEmailInsights && !isIssuesView && !isDeletedView;
    if (shouldShowInsightsSurvey) {
      feedbackClient.loadSurvey('CSAT', FEEDBACK_IDS.EMAIL_INSIGHTS);
    }
  }, [feedbackClient, hasSeenEmailInsights, isDeletedView, isIssuesView, isUngatedForAiInsights]);
  const portalId = PortalIdParser.get();
  const shouldShowPortalMigrationAlert = !getHasSeenPortalMigrationAlert(portalId);
  const {
    data: fetchCrmObjectTypeData
  } = useFetchCrmObjectType();
  const reviewContext = useReviewData(fetchCrmObjectTypeData && fetchCrmObjectTypeData.results.length > 0 ? fetchCrmObjectTypeData.results.map(c => getPropertyValue(c, PROPERTIES.MARKETING_EMAIL_ID)) : [], 'email');
  const portalMigrationHoistingHublet = useSelector(getPortalMigrationNewHoistingHublet);
  const portalMigrationStartDate = useSelector(getPortalMigrationStartDate);
  const portalMigrationEndDate = useSelector(getPortalMigrationEndDate);
  const hasAccessToSeamlessPortalMigration = useSelector(getHasAccessToSeamlessPortalMigration);
  const portalMigrationStatus = useSelector(getPortalMigrationStatus);
  const isEligibleForPortalMigration = hasAccessToSeamlessPortalMigration && !noMigrationsCategory.includes(portalMigrationStatus);
  const renderCustomColumn = useRenderCustomColumn({
    canCreateClassicEmail,
    emailTypesAuthedFor,
    reviewContext,
    isEligibleForPortalMigration,
    portalMigrationHoistingHublet,
    portalMigrationStartDate,
    portalMigrationEndDate,
    isUngatedForTimezoneUtil
  });
  const renderBulkActions = useCallback(props => isDeletedView ? /*#__PURE__*/_jsx(DeletedViewBulkActions, Object.assign({}, props)) : /*#__PURE__*/_jsx(BulkActionsHeaderContainer, Object.assign({}, ownProps, props)), [ownProps, isDeletedView]);
  const bulkActionProps = useMemo(() => ({
    canSelectAllAssets: true,
    hasBulkActions: true,
    renderBulkActions
  }), [renderBulkActions]);
  const isSearchOrFilterOnTop = useMemo(() => {
    if (listingFilters.query) {
      return SEARCH;
    } else if (listingFilters.filterGroups[0] && listingFilters.filterGroups[0].filters.length > 0) {
      return FILTER;
    } else if (listingFilters.quickFilters.length > 0) {
      return FILTER;
    } else {
      return '';
    }
  }, [listingFilters.filterGroups, listingFilters.query, listingFilters.quickFilters.length]);
  const shouldShowTranslationCoachingTip = useMemo(() => {
    return isUngatedForGenerateTranslatedVersion && fetchCrmObjectTypeData && fetchCrmObjectTypeData.total >= MIN_EMAILS_FOR_TRANSLATION_COACHING_TIP && !hasUsedAiTranslation && !isFetchingUserHasUsedAITranslation && !isDeletedView && !isIssuesView;
  }, [fetchCrmObjectTypeData, hasUsedAiTranslation, isDeletedView, isFetchingUserHasUsedAITranslation, isIssuesView, isUngatedForGenerateTranslatedVersion]);
  const renderEmptyState = useCallback(() => {
    if (isIssuesView) {
      return /*#__PURE__*/_jsx(IssuesViewEmptyState, {});
    } else if (isDeletedView) {
      return /*#__PURE__*/_jsx(DeletedViewEmptyState, {});
    } else if (isUngatedForNewFrameworkFolders && (emailUIModeProps === null || emailUIModeProps === void 0 ? void 0 : emailUIModeProps.currentUIMode) === 'FOLDERS') {
      return /*#__PURE__*/_jsx(FoldersViewEmptyState, {});
    } else {
      return /*#__PURE__*/_jsx(EmptyStateRow, {
        hasArchivedEmails: hasArchivedEmails,
        hasUsersAndTeamsAccess: hasUsersAndTeamsAccess,
        isSearchOrFilterOnTop: isSearchOrFilterOnTop,
        listMode: listMode,
        onClearAllEmailFilters: () => {
          onClearFilters();
          trackDashboardInteraction({
            otherActions: 'framework-empty-state-clear-filter'
          });
        },
        onClearEmailSearch: onClearEmailSearch,
        portalHasEmails: portalHasEmails,
        selectState: selectState,
        selectedViewPath: selectedViewPath,
        shouldDisableCreateEmailAction: shouldDisableCreateEmailAction
      });
    }
  }, [emailUIModeProps === null || emailUIModeProps === void 0 ? void 0 : emailUIModeProps.currentUIMode, hasArchivedEmails, hasUsersAndTeamsAccess, isDeletedView, isIssuesView, isSearchOrFilterOnTop, isUngatedForNewFrameworkFolders, listMode, onClearEmailSearch, onClearFilters, portalHasEmails, selectState, selectedViewPath, shouldDisableCreateEmailAction]);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "email-framework-table",
    children: [shouldShowPortalMigrationAlert && /*#__PURE__*/_jsx(PortalMigrationBanner, {
      onClose: () => setHasSeenPortalMigrationAlert(portalId),
      type: dashboardType,
      marginBlockEnd: "600"
    }), /*#__PURE__*/_jsx(ResolvedListingLibFilters, {
      filterComponent: isDeletedView ? null : /*#__PURE__*/_jsx(FrameworkTableFilters, {})
    }), /*#__PURE__*/_jsx(ResolvedListingLibLayout, {
      columnKeys: columnsToDisplay,
      actionsComponent: /*#__PURE__*/_jsx(FrameworkTableActions, {}),
      bulkActionProps: bulkActionProps,
      renderCustomColumn: renderCustomColumn,
      renderEmptyState: renderEmptyState,
      renderErrorMarker: () => /*#__PURE__*/_jsx(ErrorMarker, {}),
      renderSuccessMarker: () => /*#__PURE__*/_jsx(SuccessMarker, {})
    }), isUngatedForAiInsights && /*#__PURE__*/_jsx(UICoachingTips, {
      config: emailAIInsightsConfig
    }), shouldShowTranslationCoachingTip && /*#__PURE__*/_jsx(UICoachingTips, {
      config: emailTranslationConfig
    })]
  });
}
export default FrameworkTable;